import { render } from "./PaymentMethodsInfos.vue?vue&type=template&id=8a40dfcc&ts=true"
import script from "./PaymentMethodsInfos.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodsInfos.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__